
import { Dialog, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import './labelModel.css'

const LabelModel = (props) => {
    let labelIsNotValid = props.labelIsNotValid
    return (
        <Dialog open={props.showInvalid}
            aria-labelledby="alert-Dialog-title"
            aria-describedby="alert-Dialog-description" >
            <DialogContent>
                <DialogContentText id="alert-Dialog-description">
                    {labelIsNotValid} Contact Us:
                    <Button variant="text" >
                        <a target="_blank" rel="noopener noreferrer" href="https://jdsn-contact-us.deere.com/">
                            JDSN Contact Us</a></Button>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="primary" onClick={props.refreshHandler}>Start New Test</Button>
            </DialogActions>
        </Dialog>
    )
}

export default LabelModel;
